import { baseFetch } from 'src/utils';
import type { GetSubscriptionParams, Offer, Store } from 'src/types';

export async function getSubscriptionOffersAPI(
  store: Store,
  params: GetSubscriptionParams,
): Promise<Offer[]> {
  const { isSacPlus, cartValue, hasPrimeDeal } = params;

  const response = await baseFetch(
    `/api/subscription-offers/${encodeURIComponent(store)}/${isSacPlus}/${cartValue}${hasPrimeDeal ? '?primeDeal=true' : ''}`,
    { method: 'GET' },
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch subscription offers: ${response.statusText}`,
    );
  }

  return await response.json();
}
